import {
  getStaticPropsGenerator,
  getStaticPathsGenerator,
  GetStaticPropsGeneratorArgs,
} from '@cinch-nx/landing-feature-seo-pages'

const path = 'seo-pages/electric-cars'

export const getStaticProps = getStaticPropsGenerator(
  path as unknown as GetStaticPropsGeneratorArgs,
)

export const getStaticPaths = getStaticPathsGenerator(path)

export { SEOPageFeature as default } from '@cinch-nx/landing-feature-seo-pages'
